{
    "ErrorMessage": "Wir konnten die Audiodatei nicht laden.",
    "NAME": "MediaPlayer"
}